// onboard
import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbDividerMedium from "../webx/webb-divider-md";
import WebbLoader from "../webx/webb-loader";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { NetworkInviteList } from "../../services/srvc-network-realm";

import { Tag, Space, Row, Col, Pagination, Progress } from 'antd';


// lists --------------->

const listStatus = [
  {actv: true, done: false, color:'gold', name:'PENDING'},
  {actv: true, done: true, color:'green', name:'MINTED'},
  {actv: false, done: false, color:'red', name:'CANCELLED'},
]


export default function NetworkInviteListModule () {

  const usxx = UserForm()
  const asset = UserForm() === "in" ? GetLocalUser() : GetLocalBusiness();
  const history = useHistory();

  const [loading, setLoading] = useState(true);  
  
  const [list, setList] = useState({
    total: 0,
    done: 0
  })
  const [data, setData] = useState([])

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
     
        const result =  (await NetworkInviteList(({
          data: {usid: asset.usid, item: 100, cntr: 1},
          user: asset.usid
        }))).data
        console.log (result)
        setData(result)

        setList({
          total: result.length,
          done: result.filter(x => x.actv && x.done).length
        })

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);


  if (loading) return <WebbLoader/>


  return (
  <>
    {/* stats */}
    <div className="p-2 rounded-wd back-color-wite">
      <Row justify="start" align="middle">
        <Col >Converted</Col >
        <Col flex="auto" className="text-end">{list.done} ({list.done/list.total*100}%)</Col>
      </Row>
      <Progress percent={list.done/list.total*100} size="small" showInfo={false}/>
      <Row justify="start" align="middle">
        <Col >Total</Col >
        <Col flex="auto" className="text-end">{list.total}</Col>
      </Row>
    </div>
    <WebbDividerSmall />

    {/* add */}
    <div className={`p-1 px-2 back-color-wite rounded-wd hilite`}
      style={{cursor:'pointer'}}
      onClick={() => history.push(`/${asset.form.substring(0,2)}/network/invite/new`)}
    >
      <Row justify="space-between">
        <Col span={21}>
          <Row justify="start" align="middle">
            <Col>
              <i className="lead bx bx-user-circle text-color-tone m-0 text-icon-sm"></i>
            </Col >
            <Col flex="auto" className="mx-1">New Invite</Col>
          </Row>
        </Col>

        <Col span={3} className="text-end">
          <i className="bx bx-chevron-right text-color-tone m-0 text-icon-sm" ></i>
        </Col>
      </Row>
    </div>
    <WebbDividerMedium/>

    {/* data */}
    <div className={`back-color-wite rounded-wd`}>
    {data && data.map((item, i) => (
      <div className={`p-2 ${i < data.length-1 ? 'border-bottom': ''}`} key={i}>
      <Row justify="space-between" align="middle" >
        <Col span={21}>
          <Row justify="start" align="middle">
            <Col>
              <Row justify="start" align="middle">
                {/* <Jazzicon diameter={33} seed={jsNumberForAddress(item.acnt)} /> */}
              </Row>
            </Col >
            <Col flex="auto" className="">
              <p className="text-bold m-0">{item.usrx.name}</p>
              <p className="text-small m-0">{item.usrx.mail}</p>
            </Col>
          </Row>
        </Col>
        <Col span={3} className="text-end">
          <Row justify="center" align="middle"
            className={`text-end`}
            style={{width:'2.4rem', height:'2.4rem', borderRadius:'50%', cursor:'pointer'}}
            // onClick={() => handleChannelStatus(i, item.actv)}
            >
            <Tag className="rounded-md" color={listStatus.find( x => x.actv === item.actv && x.done === item.done).color}>
              <p className="text-mini m-0">{listStatus.find( x => x.actv === item.actv && x.done === item.done).name}</p>
            </Tag>
          </Row>
        </Col>
      </Row>
      </div>
    ))}
    </div>


    

  </>

  )
}